import { Sidebar, Header, Container, Logo } from "./styled";
import { ReactComponent as SideBarIcon } from "../../assets/sidebar.svg";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/logo.png";
import { Tooltip } from "antd";
import SidebarContent from "./SidebarContent";
import { HeaderContext } from "../../containers/MainLayout";
import { useAppDispatch } from "../../store";
import { getUserInfoThunk } from "../../store/actions/auth.action";

const SidebarComponent = () => {
  const navigate = useNavigate();
  const { isRightSideOpen } = useContext(HeaderContext);
  const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(false);
  const [isInSmallDesktop, setIsInSmallDesktop] = useState<boolean>();
  const dispatch = useAppDispatch();

  const fetchUserInfo = async () => {
    try {
      await dispatch(getUserInfoThunk());
    } catch (error) {
      console.log(error);
    }
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);

    if (isInSmallDesktop) {
      window.dispatchEvent(new CustomEvent("open-left-sidebar"));
    }
  };

  useEffect(() => {
    function checkWidth() {
      if (window.innerWidth < 1200) {
        setIsInSmallDesktop(true);
      } else {
        setIsInSmallDesktop(false);
      }
    }

    checkWidth();
    window.addEventListener("resize", checkWidth);
    return () => window.removeEventListener("resize", checkWidth);
  }, []);

  useEffect(() => {
    if (isInSmallDesktop && isRightSideOpen) {
      setIsSidebarOpen(false);
    }
    fetchUserInfo();
  }, [isInSmallDesktop, isRightSideOpen]);

  return (
    <SidebarContent
      openSidebar={isSidebarOpen}
      setOpenSidebar={setIsSidebarOpen}
      closeAfterClicked={isInSmallDesktop}
    />
  );
};

export default SidebarComponent;
